import React from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import { Grid, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import { locationBatchModelInitial } from '../../../../Models/LocationBatchModel';
import { LocationModel, locationModelInitial } from '../../../../Models/LocationModel';
import LocationService from '../../../../Services/LocationService';
import { BasicConfirmDialog } from '../../../../shared/components/BasicConfirmDialog';
import { SearchStatus } from '../../../../shared/enum/SearchStatus';
import { theme } from '../../../../theme';
import { HomeContext } from '../../../Home/HomeContext';
import { RevisionContext } from '../RevisionContext';
import ClassificationService from '../../../../Services/ClassificationService';
import { BatchCorrectionContext } from '../BatchCorrectionContext';

export function LocationBatchCorretion() {

    const revisionContext = React.useContext(RevisionContext);
    const homeContext = React.useContext(HomeContext);
    const batchCorrectionContext = React.useContext(BatchCorrectionContext);

    const [locationSelected, setLocationSelected] = React.useState<LocationModel | null>(null);
    const [locationList, setLocationList] = React.useState<LocationModel[]>([]);

    const [locationNotDefinedError, setLocationNotDefinedError] = React.useState(false);

    React.useEffect(() => {
        if (revisionContext.locationBatchOpenDialog) {
            homeContext.setOpenLoadingDialog(true);
            LocationService.getLocationByMediaId(revisionContext.mediaId)
                .then((res: AxiosResponse) => { setLocationList(res.data); })
                .catch((error: AxiosError) => { homeContext.showError('', error); })
                .finally(() => { homeContext.setOpenLoadingDialog(false); });
        }
    }, [revisionContext.locationBatchOpenDialog]);

    const hasError = () => {

        const errorLocation: boolean = (locationList && locationList.length > 0 && !locationSelected);

        setLocationNotDefinedError(errorLocation);

        return (errorLocation);
    };

    const updateLocation = () => {
        if (!hasError()) {
            homeContext.setOpenLoadingDialog(true);

            const locationData = { ...locationBatchModelInitial };
            locationData.location = locationSelected ? locationSelected : locationModelInitial;
            locationData.classificationsId = revisionContext.ids;

            ClassificationService.updateLocationBatch(locationData)
                .then(() => {
                    clearModalLocation();
                    homeContext.setOpenLoadingDialog(false);
                    homeContext.showSuccess(`As alterações foram realizadas para todas as ${revisionContext.ids.length} classificações selecionadas com sucesso!`);
                    batchCorrectionContext.setCallSearch(true);
                })
                .catch((error: AxiosError) => {
                    homeContext.showError(' Ops... Ocorreu um erro e não foi possível salvar a alteração de localização. '
                        + 'Por favor, tente novamente dentro de alguns instantes. <br/>', error);
                    homeContext.setOpenLoadingDialog(false);
                });
        }
    };

    const clearModalLocation = () => {
        revisionContext.setLocationBatchOpenDialog(false);
        setLocationList([]);
        setLocationSelected(null);
        setLocationNotDefinedError(false);
    };

    const getLocation = () => {
        return (
            <Grid item xs={12} sm={12}>
                <Autocomplete
                    id="location"
                    value={locationSelected}
                    onChange={(_, value: LocationModel | null) => setLocationSelected(value)}
                    options={locationList}
                    getOptionLabel={(option: LocationModel) => option.name}
                    fullWidth
                    noOptionsText="Sem resultados"
                    loadingText="Carregando..."
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            label="Localização"
                            variant="outlined"
                            error={locationNotDefinedError && !locationSelected}
                            helperText={locationNotDefinedError && !locationSelected ? 'Campo obrigatório' : ''} />
                    } />
            </Grid>
        );
    };

    return (
        <BasicConfirmDialog
            title={'Alteração de Localização'}
            description={'Selecione a localização que deseja para as classificações selecionadas.'}
            handleFirstButton={() => clearModalLocation()}
            handleSecondButton={() => updateLocation()}
            textFirstButton='DESCARTAR'
            textSecondButton='SALVAR'
            open={revisionContext.locationBatchOpenDialog}
            children={getLocation()}
            cssProperties={{
                minWidth: '600px',
                maxWidth: '600px',
                padding: '1rem',
                colorFirstButton: theme.palette.primary.main,
                justifyButtons: 'flex-end',
                titleVariant: 'h4',
                descriptionVariant: 'body1'
            }} />
    );
}